import { IGlobalNotificationState } from '../../state/global-notification.state';
import * as GlobalNotificationActions from '../actions/global-notification.action';
import { initialGlobalNotificationState } from '../../state/global-notification.state';

export function GlobalNotificationReducers(state: IGlobalNotificationState = initialGlobalNotificationState, action: GlobalNotificationActions.GlobalNotificationActions): IGlobalNotificationState {
    switch (action.type) {
        case GlobalNotificationActions.ERROR:
            return {
                ...state,
                successNotification: null,
                errorNotification: {
                    text: action.payload
                }
            };
        case GlobalNotificationActions.SUCCESS:
            return {
                ...state,
                errorNotification: null,
                successNotification: {
                    text: action.payload
                }
            };
        case GlobalNotificationActions.RESET:
            return {
                ...state,
                successNotification: null,
                errorNotification: null
            };
        default:
            return state;
    }
}
